import { useCallback, useState } from 'react';
import api from '../../../lib/axios';

const AGENT = 'api/v1/agent';
const CAL = 'api/v1/calendar/google';

export function useAgent() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadSettings = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const r = await api.get(`${AGENT}/settings`);
      setSettings(r.data);
      return r.data;
    } catch (err) {
      setError(err?.response?.data?.detail || err.message);
    } finally { setLoading(false); }
  }, []);

  const saveSettings = useCallback(async (patch) => {
    const r = await api.put(`${AGENT}/settings`, patch);
    setSettings(r.data);
    return r.data;
  }, []);

  const listActions = useCallback(async ({ action, limit = 50, offset = 0 } = {}) => {
    const params = { limit, offset };
    if (action) params.action = action;
    const r = await api.get(`${AGENT}/actions`, { params });
    return r.data; // { total, actions }
  }, []);

  const listAccounts = useCallback(async () => {
    const r = await api.get('email/accounts');
    return r.data?.accounts || r.data || [];
  }, []);

  const calStatus = useCallback(async (accountId) => {
    const r = await api.get(`${CAL}/status`, { params: { email_account_id: accountId } });
    return r.data; // { connected, google_email, timezone }
  }, []);

  const calConnect = useCallback(async (accountId) => {
    const r = await api.get(`${CAL}/auth_url`, { params: { email_account_id: accountId } });
    window.location.href = r.data.url;
  }, []);

  const calDisconnect = useCallback(async (accountId) => {
    await api.delete(`${CAL}/disconnect`, { params: { email_account_id: accountId } });
  }, []);

  const sendReply = useCallback(async (conversationId, body) => {
    // inbox router is mounted at /inbox (NOT /api/v1/inbox); field is `body`
    await api.post(`inbox/conversations/${conversationId}/reply`, { body });
  }, []);

  return {
    settings, loading, error,
    loadSettings, saveSettings, listActions,
    listAccounts, calStatus, calConnect, calDisconnect, sendReply,
  };
}
